import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { flattenData } from "../../../../Utilitie";
import * as echarts from "echarts";

const MonthWisePWIntNIntGraph = ({
  selectedMonths,
  selectedSections,
  sortedPrev,
  sortedCurr,
  selectedRT,
  selectedFy,
  int,
}) => {
  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};
  useEffect(() => {
    if (selectedMonths.length === 0 || selectedSections.length === 0) return;

    const chartDom = document.getElementById("pwiChart5");
    let myChart = echarts.init(chartDom);

    ////////////////////////////////////////

    const prevLTotalIntTO = selectedMonths.map((month) => {
      const m = sortedPrev.find((o) => o.month.slice(0, 3) === month);
      return selectedSections.reduce((acc, s) => {
        const d = getSectionData(m, s);
        return acc + Number(d[`${selectedRT.toLowerCase()}_to_intensive`] || 0);
      }, 0);
    });

    const currLTotalIntTO = selectedMonths.map((month) => {
      const m = sortedCurr.find((o) => o.month.slice(0, 3) === month);
      return selectedSections.reduce((acc, s) => {
        const d = getSectionData(m, s);
        return acc + Number(d[`${selectedRT.toLowerCase()}_to_intensive`] || 0);
      }, 0);
    });

    /////////////////////////////////////////////

    const prevETotalNIntTO = selectedMonths.map((month) => {
      const m = sortedPrev.find((o) => o.month.slice(0, 3) === month);
      return selectedSections.reduce((acc, s) => {
        const d = getSectionData(m, s);
        return (
          acc + Number(d[`${selectedRT.toLowerCase()}_to_nonintensive`] || 0)
        );
      }, 0);
    });

    const currETotalNIntTO = selectedMonths.map((month) => {
      const m = sortedCurr.find((o) => o.month.slice(0, 3) === month);
      return selectedSections.reduce((acc, s) => {
        const d = getSectionData(m, s);
        return (
          acc + Number(d[`${selectedRT.toLowerCase()}_to_nonintensive`] || 0)
        );
      }, 0);
    });

    //////////////////////////////////////////////  ////////////////////////////////////////

    /////////////////////////////////////////////

    //////////////////////////////////////////////

    ////////////////////////////////

    const option = {
      title: {
        text: `INT & N-INT Comparison – Prev (${selectedFy.replace(
          /\d+/g,
          (y) => +y - 1
        )}) vs Curr Year (${selectedFy})`,
        left: "center",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        top: 30,
        data: [
          `INT (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          `INT (${selectedFy})`,
          `N-INT (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          `N-INT (${selectedFy})`,
        ],
      },
      xAxis: {
        type: "category",
        data: selectedMonths,
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name:
            int === "Int"
              ? `INT (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`
              : `N-INT (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          type: "bar",
          data: int === "Int" ? prevLTotalIntTO : prevETotalNIntTO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
        {
          name: int === "Int" ? `INT (${selectedFy})` : `N-INT (${selectedFy})`,
          type: "bar",
          smooth: true,
          data: int === "Int" ? currLTotalIntTO : currETotalNIntTO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
        // {
        //   name: `N-INT (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
        //   type: "bar",
        //   data: prevETotalNIntTO,
        //   label: {
        //     show: true,
        //     position: "top",
        //     rotate: 55,
        //     fontSize: 12,
        //     verticalAlign: "middle",
        //   },
        // },
        // {
        //   name: `N-INT (${selectedFy})`,
        //   type: "bar",
        //   smooth: true,
        //   data: currETotalNIntTO,
        //   label: {
        //     show: true,
        //     position: "top",
        //     rotate: 55,
        //     fontSize: 12,
        //     verticalAlign: "middle",
        //   },
        // },
      ],
    };

    myChart.setOption(option);

    const handleResize = () => {
      myChart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      myChart.dispose();
    };
  }, [selectedMonths, selectedSections, sortedPrev, sortedCurr, selectedRT]);

  return (
    <div>
      <div className="papaDiv">
        <div
          id="pwiChart5"
          style={{ width: "100%", height: "50vh", marginTop: "30px" }}
        ></div>
      </div>
    </div>
  );
};

export default MonthWisePWIntNIntGraph;
